import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";
import moment from "moment";
// material
import { styled } from "@mui/material/styles";
import { Card, CardHeader } from "@mui/material";

// ----------------------------------------------------------------------

const CHART_HEIGHT = 372;
const LEGEND_HEIGHT = 72;

const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: 340,
  marginTop: theme.spacing(5) - 10,
  "& .apexcharts-canvas svg": { height: CHART_HEIGHT },
  "& .apexcharts-canvas svg,.apexcharts-canvas foreignObject": {
    overflow: "visible"
  },
  "& .apexcharts-legend": {
    height: LEGEND_HEIGHT,
    alignContent: "center",
    position: "relative !important",
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------

export default function ContractTimeChartPostDoc({
  postdoctoral_information = {}
}) {
  const [contractTime, setContractTime] = useState(0);

  const getUserProfile = async () => {
    const contract_end = moment(postdoctoral_information?.contract_end);
    const start_reciving = moment(postdoctoral_information?.start_reciving);
    const date_now = moment();
    const length_start_and_endDate = contract_end.diff(start_reciving, "days");
    const now_date = date_now.diff(start_reciving, "days");

    setContractTime(((now_date / length_start_and_endDate) * 100).toFixed(2));
  };
  useEffect(() => {
    getUserProfile();
  }, [postdoctoral_information]);

  const CHART_DATA = [contractTime];

  const chartOptions = {
    colors: ["#0070C0"],
    labels: ["Progress"],
    legend: { show: false },
    dataLabels: {
      enabled: false,
      formatter: function (val) {
        return val;
      },
      dropShadow: { enabled: true }
    },
    plotOptions: {
      radialBar: { hollow: { size: "50%" } }
    }
  };

  return (
    <Card>
      <CardHeader title="Contract Time" />
      <ChartWrapperStyle dir="ltr">
        <ReactApexChart
          type="radialBar"
          series={CHART_DATA}
          options={chartOptions}
          height={360}
        />
      </ChartWrapperStyle>
    </Card>
  );
}
